<template>
  <div class="fill-height">
    <v-card class="fill-height" >
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
         پرداخت
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="closed">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>


      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12">
            <v-card-title >مبلغ بدهی شما: {{ model.sumRemainder }} ریال</v-card-title>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field style="color: black"  @input="updateTextView" :error-messages="getError('amount')" dense label="مبلغ(ریال)" outlined v-model="paramRequest.amount"/>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
                :items="typeItems"
                v-model="paramRequest.typeCharge"
                dense
                outlined
                :error-messages="getError('typeCharge')"
                auto-select-first  append-icon="fas fa-angle-down"
                label="انتخاب نوع شارژ"

            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-textarea :rows="1"  :error-messages="getError('description')" dense label="توضیحات" outlined v-model="paramRequest.description"/>
          </v-col>
           <v-col cols="12" sm="4">
             <v-radio-group
                 v-model="row"
                 row
                 dense>
               <v-radio
                   v-if="model.parsian"
                   label="پارسیان"
                   value="1">
               </v-radio>
               <v-radio
                   v-if="model.bsi"
                   label="صادرات"
                   value="2">
               </v-radio>
             </v-radio-group>
          </v-col>
        </v-row>
        <span style="color: #be1e0b;margin-left: 1%; direction: rtl;">مبلغ پرداختی پس از دو روز کاری به حساب شما منظور خواهد شد.</span>

      </v-card-text>
      <v-divider class="p-0 m-0"/>
      <v-card-actions dir="ltr">
          <v-btn :loading="loading" color="success"  depressed @click="payment"> پرداخت</v-btn>
      </v-card-actions>

    </v-card>


    <form id="formPay" method="post" action="https://sepehr.shaparak.ir:8080/Pay ">
      <div>
        <input id="terminalID" type="hidden" name="terminalID"  />
        <input id="token" type="hidden" name="token"  />
        <input name="getMethod" type="hidden" required="required" value="1">
        <input type="hidden" name="nationalCode" value=" nationalCode" />
<!--        <input type="submit" value="پرداخت " class="submit" />-->
      </div>
    </form>


  </div>
</template>

<script>


import Account_se from "@/views/define/account/Account_se";



export default {
  data() {
    return {
      id: '',
      token: '',
      terminalID: '',
      row: '0',
      status: null,
      model: {},
      paramRequest:{},
      bindingErrors: [],
      typeItems: [],
      loading: false,
    }
  },


  methods: {

    updateTextView(num) {
      this.paramRequest.amount = num.toString().replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return this.paramRequest.amount

    },


    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    closed() {
      this.$root.$emit('Account')
      this.$router.go(-1)
    },

    getById: function () {
      Account_se.getById(this.id).then(response => {
        this.model = response.data.model
        this.paramRequest = response.data.pay
        this.typeItems = response.data.typeItems
      })
    },
    payment: function () {
      this.loading = true
      if (this.row === "1") {
        Account_se.paymentParsian(this.paramRequest).then(response => {
          if (response && response.status === 200) {
            this.token=response.data.token
            if (response.data.status === "0") {
              this.$session.start()
              this.$session.flash.set('token', response.data.token)
              window.location.href = 'https://pec.shaparak.ir/NewIPG/?token=' + response.data.token
            }
          } else {
            this.loading = false
            this.bindingErrors = response.response.data;
          }
        })
      }
      else if (this.row === "2") {
        Account_se.paymentBsi(this.paramRequest).then(response => {
          if (response && response.status === 200) {
              this.token=response.data.token
              this.terminalID=response.data.terminalID
           document.getElementById('terminalID').value=response.data.terminalID;
           document.getElementById('token').value=response.data.token;
            const form = document.getElementById('formPay');
              form.submit()
          }else{
            this.loading = false
            this.bindingErrors = response.response.data;
          }
        })
      }

      else if (this.row === "0") {
        this.$snack({type: 'error', message: 'یک درگاه را انتخاب کنید!'})
        this.loading = false
      }


    },


  },

  created() {
    this.id = this.$route.query.id
    this.getById()
  }


}
</script>


